// extracted by mini-css-extract-plugin
export var alignCenter = "_bq-d";
export var bannerShown = "_bq-6";
export var buttonContent = "_bq-0";
export var cardList = "_bq-1";
export var centerContent = "_bq-2";
export var chevron = "_bq-3";
export var closePanelButton = "_bq-k";
export var conversationContextContainer = "_bq-l";
export var conversationDetailContainer = "_bq-4";
export var detailWrapper = "_bq-7";
export var dropdownButton = "_bq-e";
export var dropdownTitle = "_bq-9";
export var fullHeight = "_bq-5";
export var hidden = "_bq-a";
export var icon = "_bq-b";
export var mergeSuggestionWrapper = "_bq-m";
export var panel = "_bq-i";
export var portalButtonsWrapper = "_bq-c";
export var right = "_bq-j";
export var tableSummaryContainer = "_bq-8";
export var tableSummaryHeader = "_bq-g";
export var threeDotsButton = "_bq-f";
export var wide = "_bq-h";